import { simpleStringCompare } from 'utils';

export function filterRunsByStatus(runs, ...statuses) {
  return runs.filter(function (run) {
    return statuses.includes(run.run_status);
  });
}

export function sortByClothNo(run_a, run_b) {
  return run_a.cloth_number - run_b.cloth_number;
}



// WEBPACK FOOTER //
// ./modules/GreyhoundRacing/utils/runFilter.js